<template>
  <v-card elevation="6" class="base-card-container pa-5 mt-4">
    <v-row v-if="setLoading >= 4">
      <!-- TODO:  -->
      <v-col cols="12">
        <checkBoxesCard :class="canInsertMoves == true ? '' : 'noClickEvent'" style="height: 100% !important"
          cardTitle="Liberación Jurídica" :checkBoxesInfo="denunciaQuerellaInfo" subTitlesData=""
          :extraDataInfo="extaInfo" :fatherColumSize="12" :showDisposicion="true" :valueDisposicion="valorDispocision"
          :reporteInfo="reporteInfo" :tipoProceso="4"></checkBoxesCard>
      </v-col>

      <!-- TODO:  -->
      <v-col cols="12" v-if="mostrarLibFisica" :class="canInsertMoves == true ? '' : 'noClickEvent'">
        <checkBoxesCard style="height: 100% !important" :class="editarLibFisica == true ? '' : 'no-click-event'"
          cardTitle="Liberación Física" :checkBoxesInfo="judicializacionInfo" subTitlesData=""
          :extraDataInfo="extraJudicializacionInfo" fatherColumSize="12" :reporteInfo="reporteInfo" :tipoProceso="4">
        </checkBoxesCard>
      </v-col>
    </v-row>
    <!--Movimientos-->
    <v-row>
      <v-col cols="12" md="12">
        <Movimientos @reload="reload"></Movimientos>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import reporteExpJur from "@/services/ExpJur/ExpJur.service.js";
import checkBoxesCard from "@/components/pages/Shared/components/checkBoxesCard.vue";
import tramitesButtons from "@/components/pages/Shared/components/tramites-buttons.vue";
import Movimientos from "@/components/pages/General/Movimientos/VerMovimientos.vue";
import generalServices from "@/services/ReporteGeneral/ReporteGeneral.service.js";
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";

export default {
  title() {
    return this.$route.meta.title
  },
  components: { checkBoxesCard, tramitesButtons, Movimientos },
  data() {
    return {
      checkbox: false,

      denunciaQuerellaInfo: [],
      extraDataDenunicaInfo: [],
      subTitlesDataDenuncia: [],

      judicializacionInfo: [],
      extraJudicializacionInfo: [],
      subTitlesDataJudicial: [],

      extaInfo: [
        {
          label: "Apoderado Legal",
          dato: "NO",
          editEstado: 0,
          notEditable: true,
        },
      ],



      reporteInfo: null,

      valorDispocision: null,

      extrainfoSet: false,

      tramitesOptions: [],
      setLoading: 0,

      mostrarLibFisica: false,
      editarLibFisica: false,

      volanteJuridico: false,
      canInsertMoves: false,

      checkCalidad: false,
      checkConclusion: false,
    };
  },
  async mounted() {
    this.changeReporteMenuOption("Liberación Vehículo");
    let datos = await MetodosGenerales.obtenerSessionReporte("reporte");
    this.reporteInfo = datos;
    datos.urlname = this.$route.name;
    await MetodosGenerales.guardarEnSesionInfoReporte(datos, "reporte");
    this.getInitialData();
    this.obtenerValidaJuridica();
    this.ObtenerCatalogoApartado1();
    this.ObtenerCatalogoApartado2();
  },
  methods: {
    ...mapMutations(["changeReporteMenuOption"]),
    reload(val) {
      this.$emit("ReloadEncabezado");
    },
    async getInitialData() {
      let encabezado = await reporteExpJur.EncabezadoReporte(this);
      const fhtermino = encabezado.fhtermino;

      let validaConc = await MetodosGenerales.getReporteEstatus(this);

      if (typeof fhtermino == "string") {
        this.volanteJuridico = true;
        this.canInsertMoves = true;
      } else {
        this.$swal({
          position: "center",
          icon: "warning",
          title: "Alerta",
          html: "No se pueden agregar movimientos si no hay fecha de término capturada",
          showConfirmButton: true,
          confirmButtonText: "Entendido",
          allowOutsideClick: false,
        });
      }
      if (validaConc == 2) {
        this.canInsertMoves = false;
      }
      this.setLoading = this.setLoading + 1;
    },

    async obtenerADispocisionAutoridad() {
      let response = await reporteExpJur.obtenerADispocisionAutoridad(
        this.reporteInfo
      );
      if (
        response[0].ADisposicionAuth == null ||
        response[0].ADisposicionAuth == "" ||
        response[0].ADisposicionAuth == undefined ||
        typeof response[0].ADisposicionAuth != "string"
      ) {
        this.valorDispocision = null;
      } else {
        if (response[0].ADisposicionAuth.trim() == "S") {
          this.valorDispocision = 1;
        }
        if (response[0].ADisposicionAuth.trim() == "N") {
          this.valorDispocision = 0;
        }
      }
    },
    async obtenerValidaJuridica() {
      let response = await reporteExpJur.validacionLiberacionFisica(
        this.reporteInfo
      );
      let responseCorralon = await generalServices.ObtenerCorralon(
        this.reporteInfo
      );

      if (responseCorralon[0].show == 1) {
        this.extaInfo.push({
          label: "Corralón",
          value: responseCorralon[0].prclaveCO,
          dato:
            typeof responseCorralon[0].prnombre == "string"
              ? responseCorralon[0].prnombre
              : " ",
          editEstado: 0,
          notEditable: responseCorralon[0].edit == 1 ? false : true,
          isCorralon: 1,
        });
      }

      if (response[0].somosApoderados == 1) {
        this.extaInfo[0].dato = "SI";
        this.extaInfo[0].iconValue = 0;
      }

      this.extrainfoSet = true;

      if (response[0].MostrarLibFis == 1) {
        this.mostrarLibFisica = true;
      }

      if (response[0].EditarLibFis == 1) {
        this.editarLibFisica = true;
      }

      this.setLoading = this.setLoading + 1;
    },

    async ObtenerCatalogoApartado1() {
      let tipo = 4;
      if (this.reporteInfo.aiclave == 23) {
        tipo = 6;
      }

      let response = await reporteExpJur.ObtenerCatalogoGenerico(
        this.reporteInfo,
        tipo,
        1
      );

      await this.obtenerADispocisionAutoridad();

      this.denunciaQuerellaInfo = response;

      this.setLoading = this.setLoading + 1;
    },
    async ObtenerCatalogoApartado2() {
      let tipo = 4;
      if (this.reporteInfo.aiclave == 23) {
        tipo = 6;
      }
      let response = await reporteExpJur.ObtenerCatalogoGenerico(
        this.reporteInfo,
        tipo,
        2
      );

      this.judicializacionInfo = response;
      //   const subTitulos = [...new Set(response.map((item) => item.Tipo))];
      //   this.subTitlesDataJudicial = subTitulos;
      this.setLoading = this.setLoading + 1;
    },
  },
};
</script>
@import
url('https://fonts.googleapis.com/css2?family=Poppins:wght@100;800&display=swap');

<style>
.vs-collapse-item--header {
  background-color: #536dfe !important;
}

.noClickEvent {
  pointer-events: none;
}
</style>

<style scoped>
.base-card-container {
  width: 100%;
  height: 100%;
}

.primerAtencion-container {
  background-color: white;
}

.title-card-style {
  padding: 1.5px !important;
}

.text-subtitle {
  font-family: "Poppins", sans-serif;
  font-size: 0.9em;
  color: #7e7e7e;
}

.card-title-text {
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-size: 1em;
  color: white;
}

.label-text {
  font-family: "Roboto", sans-serif;
  font-weight: 700 !important;
  font-size: 12px !important;
}

.label-text2 {
  font-family: "Roboto", sans-serif;
  font-weight: 700 !important;
  font-size: 16px !important;
}

.checkbox-title-text {
  font-family: "Roboto", sans-serif;
  font-weight: 800 !important;
  font-size: 16px !important;
  color: #adb9ff;
}

.buttons-for-checks {
  margin-bottom: 3px !important;
}

.movimiento-style-text {
  font-family: "Roboto", sans-serif;
  font-weight: 600 !important;
  font-size: 14px !important;
  color: #252525;
}

.checkbox-section-subtitle {
  font-family: "Roboto", sans-serif;
  font-weight: 800 !important;
  font-size: 14px !important;
  color: #004919;
}

.no-click-event {
  pointer-events: none;
}
</style>
